var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Instance',{attrs:{"instance":"corporation","instance-name":"Corporation","create":(d) => _vm.corporation.create(d),"delete":(d) => _vm.corporation.remove(d),"update":(d) => _vm.corporation.update(d),"get":(d) => _vm.corporation.get(d),"upsert":_vm.upsert,"columns":_vm.columns,"header":false,"headerBg":"#ffffff"}})
}
var staticRenderFns = []

export { render, staticRenderFns }